// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".review-prime-hill[data-v-e081ddca]{width:100%}.review-prime-hill__container[data-v-e081ddca]{align-items:center;border:1px solid #e6e7eb;border-radius:11px;color:#4e5672;display:flex;font-size:13px;font-weight:400;justify-content:center;line-height:18px;margin:0 16px 32px;padding:12px}.review-prime-hill__quantity[data-v-e081ddca]{color:#6764ff;font-weight:600}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
